import React, { ReactElement } from 'react';

type PropsType = {
  className?: string;
};
const ScanIcon = ({ className }: PropsType): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    fill="none"
    viewBox="0 0 31 30"
    className={className}
  >
    <path
      stroke="#01ABFB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.607"
      d="M15.499 9v4.658c0 .593.502 1.073 1.122 1.073h3.927M15.498 9l5.05 5.731M15.498 9H10.45c-.62 0-.45 1.113-.45 1.706v9.391c0 .593-.12.976.5.976h8.929c.591 0 1.071-.481 1.071-1.073v0l.048-5.269M4 11.333V6.146C4 4.961 5.005 4 6.244 4h5.423M27 18.667v5.187C27 25.039 25.995 26 24.756 26h-5.423m0-22h5.423C25.996 4 27 4.961 27 6.146v5.187M11.667 26H6.244C5.004 26 4 25.04 4 23.854v-5.187"
    />
  </svg>
);

export default ScanIcon;
